import { render, staticRenderFns } from "./KitDetails.vue?vue&type=template&id=76587e3d"
import script from "./KitDetails.vue?vue&type=script&lang=js"
export * from "./KitDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports